export const NON_DEPOSITORS = 0;
export const REGULAR = 1;
export const SUBSCRIBERS = 2;

export const NAMES = {
  [NON_DEPOSITORS]: 'Non - depositors',
  [REGULAR]: 'Regular depositors (not subscribers)',
  [SUBSCRIBERS]: 'Subscribers',
};
